import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import tc from 'tinycolor2';
import PageSectionHeading from '../../PageSectionHeading';
import ButtonSet from '../../ButtonSet';
import { colors, typography } from '../../../styles';


const styles = css`
  padding: 30px 0;
  @media (min-width: 992px) {
    padding: 90px 0;
  }
  .PageSection {
    padding: 30px 0;
    position: relative;
    z-index: 2;
    @media (min-width: 992px) {
      padding: 0 0;
      overflow: hidden;
      background-color: ${colors.white};
      &::after {
        content: '';
        display: block;
        position: absolute;
        background: linear-gradient(149.58deg, rgba(227,239,247,0) 0%, #E3EFF7 100%);
        right: 0;
        left: 0;
        top: 0;
        bottom: 0;
        z-index: 2;
      }
      &:nth-child(odd) {
        .PageSection_heading, .PageSection_body p, .PageSection_body li {
          color: ${colors.body};
        }
      }
    }
  }
  .PageSection_media {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    position: relative;
    z-index: 3;
  }
  .PageSection_image {
    width: 100%;
    height: 300px;
    margin: 0 0 30px 0;
    padding: 0 15px;
    object-fit: cover;
    object-position: center center;
    @media (min-width: 1200px) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      margin: 0 0 0 0;
      padding: 0;
    }
  }
  .PageSection_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: 0 10px;
    position: relative;
    z-index: 3;
    @media (min-width: 1200px) {
      padding: 180px 75px 180px 45px;
    }
    @media (min-width: 1600px) {
      padding: 180px 150px 180px 75px;
    }
  }
  .PageSection_contentHeader {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    @media (min-width: 992px) {
      justify-content: flex-start;
      align-items: flex-start;
    }
  }
  .PageSection_number, .PageSection_questionGraphic {
    width: 80px;
    height: 80px;
    line-height: 80px;
    border-radius: 50%;
    margin: 0 0 15px 0;
    background-color: ${tc(colors.brand2).setAlpha(0.8).toRgbString()};
    text-align: center;
    color: ${colors.white};
    font-size: 40px;
    font-family: ${typography.Serif};
    flex-shrink: 0;
    @media (min-width: 992px) {
      margin: 0 0 30px 0;
      background-color: ${tc(colors.brand2).setAlpha(0.5).toRgbString()};
    }
  }
  .PageSection_number {
    position: relative;
    width: 120px;
    height: 120px;
    font-size: 70px;
    line-height: 120px;
    font-family: ${typography.Serif};
    color: ${colors.brand1};
    margin: -90px 0 25px 30px;
    @media (min-width: 992px) {
      position: relative;
      width: 268px;
      height: 268px;
      font-size: 100px;
      line-height: 268px;
      font-family: ${typography.Serif};
      color: ${colors.brand1};
      margin: 0 0 50px -120px;
    }
  }
  .PageSection_answerGraphic {
    width: 100px;
    height: 80px;
    line-height: 80px;
    border-radius: 50%;
    margin: 15px 0;
    background-color: ${colors.brand3};
    text-align: center;
    color: ${colors.white};
    font-size: 40px;
    font-family: ${typography.Serif};
    flex-shrink: 0;
    @media (min-width: 992px) {
      margin: 0 30px 0 0;
    }
  }
  .PageSection_heading {
    font-size: 21px;
    line-height: 1.2;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-align: center;
    position: relative;
    @media (min-width: 480px) {
      font-size: 36px;
      letter-spacing: 2px;
    }
    @media (min-width: 992px) {
      text-align: left;
    }
    &::after {
      content: '';
      display: block;
      margin: 10px 0;
      width: 75px;
      height: 2px;
      background-color: ${colors.brand3};
      @media (min-width: 480px) {
        margin: 20px auto;
      }
      @media (min-width: 992px) {
        margin: 30px 0;
      }
    }
  }
  .PageSection_bodyWrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    @media (min-width: 992px) {
      flex-direction: row;
      align-items: flex-start;
    }
  }
  .PageSection_body {
    text-align:left;
    @media (min-width: 992px) {
      text-align:left;
    }
    p {
      @media (min-width: 992px) {
      }
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 0 0 30px 0;
    }
    li {
      font-size: 17px;
      line-height: 1.8;
      font-weight: 200;
      margin: 0 0 20px 0;
      font-family: ${typography.Condensed};
      padding: 0 0 0 30px;
      position: relative;
      @media (min-width: 992px) {
        font-size: 25px;
      }
      &::before {
        content: '';
        display: block;
        position: absolute;
        width: 8px;
        height: 8px;
        background-color: ${colors.brand2};
        top: 18px;
        left: 0;
      }
    }
  }
  .AlternatingElement_1 {
    @media (min-width: 992px) {
      padding-right: 0;
    }
  }
  .AlternatingElement_2 {
    @media (min-width: 992px) {
      padding-left: 0;
    }
  }
  .PageSection_alternating {
    .PageSection:nth-child(even) {
      @media (min-width: 992px) {
          .AlternatingElement_1 {
            order: 2;
            padding-right: 15px;
            padding-left: 0;
          }
          .AlternatingElement_2 {
            order: 1;
            padding-right: 0;
            padding-left: 15px;
          }
      }
    }
  }
`;

function PageSections({ content }) {
  return (
    <div className={styles}>
      {
        get(content, '[0].section_heading') &&
        <PageSectionHeading h3={get(content, '[0].section_heading')} underdog />
      }
      <div className={get(content, '[0].alternating') ? 'PageSection_alternating' : ''}>
        {
          get(content, '[0].page_sections', []).map((section, index) => (
            <div className="PageSection" key={section._id}>
              <div className="container-fluid">
                <div className="row justify-content-center">
                  {
                    get(section, 'image.contentUrl') &&
                    <div className="col-lg-6 px-xl-0 AlternatingElement_1">
                      <div className="PageSection_media">
                        <Image
                          className="PageSection_image"
                          src={get(section, 'image.contentUrl')}
                          width={1200}
                          height={1200}
                          alt={get(section, 'image.name', get(section, 'image.caption'), '')}
                        />
                      </div>
                    </div>
                  }
                  <div className="col-lg-6 px-xl-0 AlternatingElement_2">
                    <div className="PageSection_content">
                      {
                        section.title &&
                        <div className="PageSection_contentHeader">
                          {
                            get(content, '[0].show_numbers') &&
                            <div className="PageSection_number">{index + 1}</div>
                          }
                          {
                            get(content, '[0].show_qa_graphics') &&
                            !get(content, '[0].show_numbers') &&
                            <div className="PageSection_questionGraphic">Q</div>
                          }
                          <h3 className="PageSection_heading">{get(section, 'title')}</h3>
                        </div>
                      }
                      {
                        section.body &&
                        <div className="PageSection_bodyWrapper">
                          {
                            get(content, '[0].show_qa_graphics') &&
                            !get(content, '[0].show_numbers') &&
                            <div className="PageSection_answerGraphic">A</div>
                          }
                          <div className="PageSection_body" dangerouslySetInnerHTML={SanitizeHtml(get(section, 'body'))} />
                        </div>
                      }
                      <ButtonSet buttonSetParent={section} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
        ))
      }
      </div>
    </div>
  );
}

PageSections.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

PageSections.defaultProps = {
};

export default PageSections;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PageSections.section.js